import {
  useCallback,
  useEffect,
} from 'react';
import {
  useDispatch
} from 'react-redux';
import {
  useSessionSelector,
  selectHasFirstTimeDepositTag,
} from '@entities/session';
import {
  useWelcomeOfferSelector,
  selectWelcomeOfferTimerId,
  selectWelcomeOfferModalOpen,
  setWelcomeOfferTimerId,
  setOpenWelcomeOfferModal,
} from '../model';
import {
  WELCOME_OFFER_MODAL_DELAY
} from '../config';

export const useWelcomeOfferModalVisibility = () => {
  const dispatch = useDispatch();

  const modalOpen = useWelcomeOfferSelector(selectWelcomeOfferModalOpen);
  const timerId = useWelcomeOfferSelector(selectWelcomeOfferTimerId);
  const hasFirstTimeDepositTag = useSessionSelector(selectHasFirstTimeDepositTag);

  const handleOpenWelcomeOfferModal = () => {
    if (!hasFirstTimeDepositTag && !timerId) {
      dispatch(
        setWelcomeOfferTimerId(
          setTimeout(() => {
            dispatch(setOpenWelcomeOfferModal(true));
          }, WELCOME_OFFER_MODAL_DELAY))
      );
    }
  };

  const handleCloseWelcomeOfferModal = useCallback(() => {
    dispatch(setOpenWelcomeOfferModal(false));
  }, []);

  useEffect(() => {
    if (hasFirstTimeDepositTag && timerId) {
      clearTimeout(timerId);
      handleCloseWelcomeOfferModal();
    } else {
      handleOpenWelcomeOfferModal();
    }
  }, [hasFirstTimeDepositTag]);

  return { modalOpen, handleCloseWelcomeOfferModal };
};
